import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/index/HomeView.vue'
import { timecheck } from '@/utils/tools'
import axios from 'axios'
Vue.use(VueRouter)

const routes = [
  {
    path: '/home',
    name: 'home',
    component: HomeView
  },
  {
    path: '/',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/cloumn/index.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
let firstEnter = true
router.beforeEach((to, from, next) => {
  console.log(localStorage.getItem('timeCheck'), 'localStorage.getItem',window.location)
  if (localStorage.getItem('timeCheck') == null||firstEnter) {
    let url = `${window.origin}/ts?t=${Date.now()}`
    axios({
      url,
      timeout: 3000
    })
      .then((res) => {
        if (res) {
          // 获取时间差异
          let time = Number(Date.now() / 1000).toFixed(0) - Number(res.data.timestamp).toFixed(0)
          localStorage.setItem('timeCheck', time)
          firstEnter = true
          next()
        }
      })
      .catch((err) => {
        firstEnter = true
        localStorage.setItem('timeCheck', 0)
        next()
        // 是否为轻量包调用
      })
  }else{
    next()
  }
  console.log('routerYanzheng')
})
export default router
